module.exports = __webpack_public_path__ + "static/media/confirm-result-herdy-group-3.c67b7c83.svg";